enum BlogSections {
  generalResults = 'general-results',
  authors = 'authors',
  home = 'home',
}

export default BlogSections;
